import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Card, Grid, Button} from 'semantic-ui-react';
import FiltersSectionMultiple from '../../../common/components/dateFilterMultiple/dateFiltersSectionMultiple';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import DataTable from './dataTable';
import {isEqual} from 'lodash';

const years = [{
  'year': 2019,
}, {
  'year': 2020,
}, {
  'year': 2021,
}, {
  'year': 2022,
}, {
  'year': 2023,
}, {
  'year': 2024,
}, {
  'year': 2025,
}, {
  'year': 2025,
}, {
  'year': 2026,
}];

class DailyVehiclesSalesAndStockWholesale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'clientSelected': '1792073634001',
      'dateFilters': {},
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DailyVehiclesSalesAndStockWholesales, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {dateFilters} = this.state;
    if (!isEqual(prevState.dateFilters, dateFilters)) {
      this.onSearchClick();
    }
  }

  onSearchClick = () => {
    const filters = this.getFilters();
    this.props.fetchDailyVehiclesWholeSalesAndStockSummary(filters);
  }

  getFilters = () => {
    const {clientSelected, dateFilters} = this.state;
      
    const filters = {};
    if (clientSelected && clientSelected !== 'all') {
      filters.clientId = clientSelected;
    }
    if (dateFilters) {
      filters.startDate = dateFilters.startDate;
      filters.endDate = dateFilters.endDate;
    }
    return filters;
  }

  onUpdateDateFiltersClick = (dateFilters) => {
    this.setState({
      dateFilters,
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
    });
  }

  render() {
    const {clearFilters, clientSelected} = this.state;
    const {loading} = this.props;

    return (
      <div className='daily-vehicles-sales-and-stock-summary'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Ventas y Stock diario Wholesale</h2>
              <div className='title-bar-actions'>
                <Button type='button' primary className='toyota-primary' disabled={loading} loading={loading}
                  onClick={this.onSearchClick.bind(this)}>Buscar</Button>
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row textAlign='center'>
                  <Grid.Column width={16}>
                    <FiltersSectionMultiple years={years} clearFilters={clearFilters}
                      onDateFiltersClick={this.onUpdateDateFiltersClick.bind(this)} showDays={true} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <DataTable dealerSelected={clientSelected} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dailyVehiclesSalesAndStockWholesale.loading,
    'permissions': state.session.permissions,
  };
};

const {

  fetchDailyVehiclesWholeSalesAndStockSummary,
} = Actions;

export default connect(mapStateToProps, {
  fetchDailyVehiclesWholeSalesAndStockSummary,
})(DailyVehiclesSalesAndStockWholesale);
